module.exports = __webpack_public_path__ + "static/img/icon-circle-arrow.e97c28e.png";